import store from './store';

export * from './actions';

export const iamStore = store;
